<!-- <app-loading-modal
  [isVisible]="loadingModal"
  [showSpinner]="loadingStep === 'spinner'"
  [message]="loadingMessage"
  [scrollTarget]="nextSectionId"
  (closed)="onLoadingModalClosed($event)">
</app-loading-modal> -->

<div #step0></div>
<div #step1></div>
<div #step2></div>
<div #step3></div>
<div #step4></div>
<div #step5></div>
<div #step6></div>
<div #step7></div>
<div #step8></div>
<div #step9></div>
<div #step10></div>

<!-- <app-pdf-guide-sell
  [guide]="{
    title: 'Guía para obtener el visado de estudios en España',
    description: 'Todo lo que necesitas saber sobre requisitos, documentos, procesos y tiempos.',
    imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ffd61471-34b1-43da-4cc2-cd3748415a00/public',
    shopifyLink: 'https://tutienda.myshopify.com/products/guia-visado-estudios',
    variantId: 51262754849071
  }"
></app-pdf-guide-sell> -->


<!-- PROGRESO DE CONTRATACION -->
<div class="insurance-progress-card" *ngIf="showProgress()">
  <h2 class="webapp-pre-title">Estado del proceso de contratación</h2>
  <p>A continuación te mostramos los pasos que has completado y los que faltan.</p>
  
  <div class="step-summary flex-col" [ngClass]="{'completed': true}" *ngIf="summaryStepsVisible().length>0 && processStatus>1 && processStatus <10">
    <ul>
      <li *ngIf="processStatus > 3 && processStatus <10" class="nomargin strong comp"><mat-icon class="icon-sm completed">check_circle</mat-icon> Paso 1: Solicitud</li>
      <li *ngIf="processStatus > 6 && processStatus <10" class="nomargin strong comp"><mat-icon class="icon-sm completed">check_circle</mat-icon> Paso 2: Adjuntar documentación</li>
      <li *ngIf="processStatus > 7 && processStatus <10" class="nomargin strong comp"><mat-icon class="icon-sm completed">check_circle</mat-icon> Paso 3: Esperar resolución</li>
      <li *ngIf="processStatus > 8 && processStatus <10" class="nomargin strong comp"><mat-icon class="icon-sm completed">check_circle</mat-icon> Paso 4: Realizar pago</li>

      <li *ngIf="processStatus < 3" class="nomargin comp"><mat-icon class="icon-sm completed"></mat-icon> Paso 1: Solicitud</li>
      <li *ngIf="processStatus < 7" class="nomargin comp"><mat-icon class="icon-sm completed"></mat-icon> Paso 2: Adjuntar documentación</li>
      <li *ngIf="processStatus < 8" class="nomargin comp"><mat-icon class="icon-sm completed"></mat-icon> Paso 3: Esperar resolución</li>
      <li *ngIf="processStatus < 9" class="nomargin comp"><mat-icon class="icon-sm completed"></mat-icon> Paso 4: Realizar pago</li>
    </ul>
  </div>
</div>

<!-- STEP 0 - CONTRATAR SEGURO MEDICO - RECIBIR INFO VIA EMAIL -->
<div class="card" *ngIf="isStepVisible(0)">
    <h1 class="webapp-title">Contratar seguro médico</h1>
    <h5 class="webapp-pre-title">Obligatorio para visado y NIE</h5>
    <!-- Offer Description -->
    <p>Te ofrecemos un <strong>seguro médico</strong> de la aseguradora <strong>ASISA</strong> con todas las coberturas necesarias para tu estancia en el extranjero.</p>
    <p class="price">
      💶 Precio aproximado por 12 meses: <strong>448,80 EUR</strong>
    </p>
    <p>Para tramitarlo, necesitamos reunir tu información personal y nosotros gestionamos toda la solicitud. Recibirás un <strong>enlace seguro</strong> para realizar el pago y obtendrás el <strong>comprobante de cobertura en PDF</strong> para tu visado.</p>
    <!-- Checklist of Requirements -->
    <h2 class="webapp-title-secondary">Información requerida:</h2>
    <ul class="requirements">
      <li>📄 Fotografía/escaneo de la primera página de tu pasaporte.</li>
      <li>🏫 Carta de admisión al centro de estudios.</li>
      <li>📅 Elegir fecha de inicio y fecha de fin.</li>
    </ul>
  
    <!-- Email Input -->
    <div *ngIf="!isEmailInfoSent()" class="email-section">
      <p>Introduce tu correo electrónico y te enviaremos estas instrucciones:</p>
      <form [formGroup]="emailForm">
        <!-- EMAIL INPUT -->
        <mat-form-field class="my-mat-form-field"> 
            <mat-label>{{'AUTH.REGISTER.EMAIL_PLACEHOLDER' | translate}}</mat-label>
            <input matInput placeholder="{{getTranslationFor('AUTH.LOGIN.EMAIL_PLACEHOLDER')}}"  type="email" class="my-mat-fields" formControlName="email" required>
        </mat-form-field>

        <!-- SEND EMAIL -->
        <button mat-button type="submit" (click)="sendNotificationEmails()" class="button button-bordered color-light button-round" [disabled]="!emailForm.valid">
          <span>{{'HEALTH.REQUEST_INFO_BUTTON' | translate}}</span> <!--  -->
        </button>

        <div *ngIf="emailForm.controls.email.invalid && emailForm.controls.email.touched" class="error">
          Por favor, introduce un correo válido.
        </div>
      </form>
    </div>
    
    <!-- Success Message -->
    <div *ngIf="isEmailInfoSent()" class="success-message">
      ✅ ¡Instrucciones enviadas! <!-- Haz click en 'Contratar Seguro' para comenzar tu proceso de solicitud. -->
    </div>

    <!-- CONTRATAR -->
   <!--  <button mat-button (click)="buyProduct('buySeguroMedico')" class="button btn-premium color-action button-round">
      <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isStatus('processing')"></mat-spinner>
      <span *ngIf="!isStatus('processing')">{{'HEALTH.HIRE_BUTTON' | translate}}</span>
    </button> -->

    <div *ngIf="isStatus('processing')" class="loading-overlay center">
      <div class="spinner"></div>
      <p>Procesando orden...</p>
    </div>
</div>

<!-- STEP 1 - DATOS DE LA COBERTURA DEL SEGURO MEDICO -->
<div class="card insurance-card" *ngIf="isStepVisible(1)">
  <h2 class="webapp-pre-title">Paso 1</h2>
  <form [formGroup]="seguroForm">
    <div class="section">
      <h2 class="webapp-title-secondary">Datos de cobertura del seguro médico:</h2>
      <p class="alert"><strong>* Recuerda:</strong> el inicio del seguro será <strong>siempre</strong> el <strong>día 1 del mes</strong> que elijas.</p>
      <div class="flex-row" style="justify-content: space-between;">
        <!-- AÑO INICIO -->
        <div class="flex-col w45">
          <mat-label>Año de inicio</mat-label>
          <mat-button-toggle-group name="anioDeInicio" aria-label="Año de inicio" formControlName="anioInicio">
            <mat-button-toggle value="2025">2025</mat-button-toggle>
            <mat-button-toggle value="2026">2026</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <!-- MES INICIO -->
        <mat-form-field class="w50">
          <mat-label>Mes Inicio</mat-label>
          <mat-select formControlName="mesInicio">
            <mat-option *ngFor="let mes of meses" [value]="mes.value">{{ mes.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  
    <!-- DETALLES ESTUDIOS -->
    <div class="section">
      <h2 class="webapp-title-secondary">Detalles de estudios:</h2>
      <div class="flex-col full-width">
        <mat-form-field class="">
          <mat-label>Universidad / Centro de estudios</mat-label>
          <input matInput placeholder="Indica Universidad / Centro de estudios" formControlName="university" />
        </mat-form-field>
  
        <mat-form-field class="full-width">
          <mat-label>Duración del curso</mat-label>
          <mat-select formControlName="duracionCurso">
            <mat-option *ngFor="let duracion of duraciones" [value]="duracion.value">{{ duracion.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
  
    <button mat-button type="submit" (click)="saveInsuranceData()" class="button button-fill color-action button-round w45 right" [disabled]="!seguroForm.valid">
      <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
      <span *ngIf="!isLoading()">{{'BUTTONS.NEXT' | translate}}</span>
    </button>
  </form>
</div>

<!-- STEP 2 - DATOS PERSONALES ESTUDIANTE -->
<div class="card insurance-card" *ngIf="isStepVisible(2)">
  <h2 class="webapp-pre-title">Paso 1</h2>
  <form [formGroup]="studentForm" class="form-container" *ngIf="!loading">
    <h2 class="webapp-title-secondary">Datos del estudiante:</h2>
    
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nombre completo</mat-label>
      <input matInput formControlName="name" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Primer Apellido</mat-label>
      <input matInput formControlName="lastname1" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Segundo Apellido</mat-label>
      <input matInput formControlName="lastname2" required />
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Fecha de nacimiento</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="birthDate" required />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <div class="flex-row between">
      <mat-form-field appearance="outline" class="field-with-help">
        <mat-label>Número de pasaporte</mat-label>
        <input matInput formControlName="passportNumber" required />
      </mat-form-field>
      <mat-icon class="help-icon" (click)="passportHelp = !passportHelp">help_outline</mat-icon>
    </div>
    <div *ngIf="passportHelp">
      <p class="help-msg">Debes utilizar el <strong>valor alfanumérico del pasaporte.</strong></p>
    </div>
    
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>¿Con qué género te identificas?</mat-label>
      <mat-select formControlName="gender" required>
        <mat-option value="M">Hombre</mat-option>
        <mat-option value="F">Mujer</mat-option>
        <mat-option value="Otro">No binario</mat-option>
        <mat-option value="Otro">Otro</mat-option>
        <mat-option value="Otro">Prefiero no decirlo</mat-option>
      </mat-select>
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Domicilio</mat-label>
      <mat-select formControlName="address" required>
        <mat-option value="España">España</mat-option>
        <mat-option value="Extranjero">Extranjero</mat-option>
      </mat-select>
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>País de origen</mat-label>
      <input matInput formControlName="country" required />
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" required />
    </mat-form-field>
  
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Teléfono</mat-label>
      <input matInput type="tel" formControlName="phone" required />
    </mat-form-field>

  </form>

  <!-- PRIVACY POLICY -->
  <app-accept-terms-check [version]="'v1.0'" [label]="policyCheckLabel" [url]="'https://www.voyjaleas.com/#/privacy-policy'" [type]="'privacy'" (policyChecked)="onPolicyChecked($event)"></app-accept-terms-check>
 
  <!-- ACCEPT TERMS AND CONDITIONS -->
  <app-accept-terms-check [version]="'v1.0'" [label]="termsAndConditionsLabel" [url]="'https://www.voyjaleas.com/#/terms'" [type]="'terms'" (policyChecked)="onTermsChecked($event)"></app-accept-terms-check>

  <button mat-button type="submit" (click)="saveStudentInfo()" class="button button-fill color-action button-round  w45 right" [disabled]="!isStudentFormValid()">
    <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
    <span *ngIf="!isLoading()">{{'BUTTONS.NEXT' | translate}}</span>
  </button>
</div>

<!-- STEP 3 - UPLOAD DOCS PASAPORTE AND CARTA ACEPT -->
<div class="card insurance-card" *ngIf="isStepVisible(3)">
  <h2 class="webapp-pre-title">Paso 1</h2>
  <div class="upload-section">
    <h2 class="webapp-title-secondary">Documentos requeridos</h2>
    <p>Sube los siguientes documentos para gestionar la solicitud de tu seguro médico.</p>
    <!-- PASAPORTE -->
    <app-file-upload [fileId]="'passport'" [pickerLabel]="'🪪 Fotocopia del pasaporte'" [formatsAccepted]="'.pdf,.jpg,.jpeg,.png,.doc,.docx'" (selectedFile)="localSaveFile($event)"></app-file-upload>
    <!-- CARTA DE ACEPTACIÓN -->
    <app-file-upload [fileId]="'cartaAceptacion'" [pickerLabel]="'📄 Carta de aceptación universidad'" [formatsAccepted]="'.pdf,.jpg,.jpeg,.png,.doc,.docx'" (selectedFile)="localSaveFile($event)"></app-file-upload>
    
    <button class="button button-fill color-light button-round" *ngIf="failedUploads.length > 0" (click)="retryFailedUploads()">Reintentar documentos fallidos</button>

    <button mat-button type="submit" (click)="uploadDocuments()" class="button button-fill color-action button-round w45 right" [disabled]="!areFilesUploaded()">
      <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
      <span *ngIf="!isLoading()">{{'BUTTONS.NEXT' | translate}}</span>
    </button>
    
  </div>
</div>

<!-- STEP 4 - MENSAJE PARA ESPERAR POR LOS FORMULARIOS -->
<div class="card insurance-card" *ngIf="isStepVisible(4)">
  <div class="modal-header">
    <mat-icon class="modal-icon">assignment_turned_in</mat-icon>
    <h2 class="title">¡Documentos subidos!</h2>
  </div>
  <div>
    <p class="message">
      Hemos recibido la<strong> información de tu solicitud.</strong> Procedemos a revisar los documentos.
    </p>
    <h2 class="webapp-title-secondary steps-title">¿Qué sucede ahora?</h2>
    <ul>
      <li><mat-icon class="step-icon">picture_as_pdf</mat-icon>  Te enviaremos el formulario de solicitud del seguro médico que deberás completar <strong>y firmar a mano.</strong></li>
      <li><mat-icon class="step-icon">picture_as_pdf</mat-icon>  Te enviaremos el cuestionario de ASISA que deberás completar <strong>y firmar a mano.</strong></li>
    </ul>
  </div>
</div>

<!-- STEP 5 - MODAL TO DOWNLOAD FORM AND QUEST -->
<div class="card insurance-card" *ngIf="isStepVisible('5')">
  <h2 class="webapp-pre-title">Paso 2</h2>
  <h2 class="webapp-title-secondary">Descarga y rellena los documentos</h2>
  <p class="lead mb-4 text-muted">Los documentos de ASISA están listos para que los completes.</p>
  <ul>
    <li>1. Descarga los documentos.</li>
    <li>2. Completa los datos de cada documento</li>
    <li>3. Firma a mano ambos documentos.</li>
    <li>4. Súbelos en la siguiente pantalla.</li>
  </ul>
  <!-- Formulario -->
  <!-- Cuestionario -->
  <ul>
    <li><mat-icon class="step-icon">picture_as_pdf</mat-icon><strong>Formulario de solicitud de seguro</strong></li>
    <li><mat-icon class="step-icon">picture_as_pdf</mat-icon><strong>Cuestionario de Salud ASISA</strong></li>
  </ul>
  
  <button mat-button type="submit" (click)="descargarDocumentos()" class="button button-bordered color-light button-round">
    <span >{{'BUTTONS.DOWNLOAD_ZIP' | translate}}</span>
  </button>

  <button mat-button type="submit" (click)="goToNextStep()" class="button button-fill color-action button-round w45 right">
    <span >{{'BUTTONS.NEXT' | translate}}</span>
  </button>
</div>

<!-- STEP 6 - SUBIR DOCS RELLENOS FORM & QUEST SIGNED - STEP 6 -->
<div class="card insurance-card" *ngIf="isStepVisible('6')">
  <h2 class="webapp-pre-title">Paso 2</h2>
  <div class="upload-section">
    <h2 class="webapp-title-secondary">Subida de Documentos</h2>
    <p>Sube los documentos rellenos y firmados a mano y los enviaremos a la aseguradora para su aprobación.</p>
    <!-- PASAPORTE -->
    <app-file-upload [fileId]="'formularioRelleno'" [pickerLabel]="'📝 Formulario de solicitud'" [formatsAccepted]="'.pdf,.jpg,.jpeg,.png,.doc,.docx'" (selectedFile)="localSaveFile($event)"></app-file-upload>
    <!-- CARTA DE ACEPTACIÓN -->
    <app-file-upload [fileId]="'cuestionarioRelleno'" [pickerLabel]="'📋 Cuestionario de ASISA'" [formatsAccepted]="'.pdf,.jpg,.jpeg,.png,.doc,.docx'" (selectedFile)="localSaveFile($event)"></app-file-upload>

    <button mat-button type="submit" (click)="uploadDocuments()" class="button button-fill color-action button-round w45 right" [disabled]="!areFilesUploaded()">
      <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
      <span *ngIf="!isLoading()">{{'BUTTONS.NEXT' | translate}}</span>
    </button>
    
  </div>
</div>

<!-- STEP 7 - MODAL DE ESTAMOS GENERANDO LOS DOCUMENTOS/FORM y CUESTIONARIO -->
<div class="card insurance-card" *ngIf="isStepVisible('7')">
  <div class="modal-header">
    <mat-icon class="modal-icon">send</mat-icon>
    <h2 class="title">¡Solicitud enviada con éxito!</h2>
  </div>
  <div>
    <p class="message">Tu solicitud ha sido <strong>procesada correctamente</strong> y la hemos enviado a la aseguradora <strong>ASISA</strong> para su aprobación.</p>
    <h2 class="webapp-title-secondary steps-title">¿Qué sucede ahora?</h2>
    <ul>
      <li><mat-icon class="step-icon">hourglass_top</mat-icon> Esperar resolución por parte de ASISA.</li>
      <li><mat-icon class="step-icon">link</mat-icon> Te enviaremos un <strong> enlace de pago </strong> cuando sea aprobado.</li>
      <li><mat-icon class="step-icon">picture_as_pdf</mat-icon> Tras el pago, recibiremos el <strong>comprobante en PDF</strong>.</li>
      <li><mat-icon class="step-icon">email</mat-icon> Te lo enviaremos y se activará tu cobertura médica.</li>
    </ul>
  </div>
</div>

<!-- STEP 8 - WAITING FOR CLIENT TO PAY -->
<div class="card insurance-card" *ngIf="isStepVisible('8')">
  <div class="modal-header">
    <mat-icon class="modal-icon">thumb_up</mat-icon>
    <h2 class="title">¡Seguro médico aprobado!</h2>
  </div>
  <div>
    <p class="message">Buenas noticias, tu solicitud de seguro médico <strong>ha sido aprobada.</strong> Ahora debes accceder a tu email y <strong>realizar el pago.</strong> Cuando hayas realizado el pago entra en nuestra aplicación y haz click en el botón de <strong>pago realizado</strong> para gestionar el envío del comprobante de cobertura en PDF.</p>
    <h2 class="webapp-title-secondary steps-title">¿Qué sucede ahora?</h2>
    <ul class="next-steps">
      <li><mat-icon class="step-icon">picture_as_pdf</mat-icon> ASISA nos enviará el <strong>comprobante en PDF</strong>.</li>
      <li><mat-icon class="step-icon">email</mat-icon> Te lo enviaremos por correo y se activará tu cobertura médica.</li>
    </ul>

    <button mat-button type="submit" (click)="goToNextStep()" class="button button-fill color-action button-round">
      <span >{{'BUTTONS.SEGURO_PAID' | translate}}</span>
    </button>
  </div>
</div>

<!-- STEP 9 - USER PAID - WAITING FOR CERTIFICADO COBERTURA-->
<div class="card insurance-card centered" *ngIf="isStepVisible('9')">
  <div class="modal-header">
    <mat-icon class="modal-icon">hourglass_top</mat-icon>
    <h2 class="title">Preparando certificado</h2>
  </div>
  <div>
    <p class="message">Gracias por realizar el proceso con <strong>VoyJaleas </strong> y ASISA. En este momento la aseguradora está <strong> generando el documento de cobertura</strong> de tu seguro médico. Te lo haremos llegar vía email cuando lo recibamos. También lo podrás descargar aquí.</p>
  </div>
</div>

<!-- STEP 10 - DOWNLOAD CERTIFICADO COBERTURA PDF -->
<div class="card insurance-card centered" *ngIf="isStepVisible('10')">
  <div class="modal-header">
    <mat-icon class="modal-icon"><i class="fa-regular fa-file-pdf"></i></mat-icon>
    <h2 class="title">Certificado de cobertura listo</h2>
  </div>
  <div>
    <p class="message">Buenas noticias, ya está disponible tu <strong>certificado de cobertura de seguro médico</strong> en PDF. Lo puedes descargar aquí o bien en el email que te hemos enviado.</p>
    <h2 class="webapp-title-secondary steps-title">Siguientes pasos</h2>
    <ul>
      <li><mat-icon class="step-icon">account_box</mat-icon>Cuando tengas una dirección coordinaremos el envío de tu <strong>tarjeta de seguro de ASISA.</strong></li>
      <li><mat-icon class="step-icon">folder</mat-icon>Este certificado de cobertura será el documento que debes presentar en la cita del visado de estudiante.</li>
    </ul>

    <div class="pdf-file">
      <div class="step-content flex-row between" style="align-items: center;">
        <mat-icon class="doc-icon margin-1rem text-color"><i class="fas fa-file-alt"></i></mat-icon>
        <h4 class="text-color">Certificado de cobertura: Seguro de Salud ASISA</h4>
      </div>
    </div>
  
    <button mat-button type="submit" (click)="descargarCertificadoPDF()" class="button button-bordered color-light button-round">
      <span >{{'BUTTONS.DOWNLOAD_PDF' | translate}}</span>
    </button>

    <button mat-button type="submit" (click)="goToNextStep()" class="button button-fill color-action button-round w45 right">
      <span >{{'BUTTONS.NEXT' | translate}}</span>
    </button>

  </div>
</div>

<!-- STEP 11 - DATOS DEL SEGURO MÉDICO -->
<div class="card insurance-card centered" *ngIf="isStepVisible('11')">
  <div class="modal-header">
    <mat-icon class="modal-icon dark-color">info</mat-icon>
    <h2 class="webapp-title-secondary nomargin">Información de tu seguro médico</h2>
    <h2 class="webapp-pre-title">ASISA</h2>
  </div>
  <div>
    <p class="message">Estos son los datos de tu seguro médico contratado:</p>
    <ul>
      <li class="comp"><mat-icon class="step-icon icon-sm">calendar_today</mat-icon>Inicio: <strong><app-date-render [date]="omnibusContract.startDate" [format]="'short'"></app-date-render></strong></li>
      <li class="comp"><mat-icon class="step-icon icon-sm">calendar_today</mat-icon>Fin: <strong><app-date-render [date]="omnibusContract.endDate" [format]="'short'"></app-date-render> </strong></li>
      <li class="comp"><mat-icon class="step-icon icon-sm">access_time</mat-icon>Para un total de   <strong>{{this.omnibusContract.monthsDuration}} meses</strong>  de cobertura.</li>
    </ul>
  </div>
</div>

<!-- DEBUG: PREV Y NEXT -->
<div class="flex-col" *ngIf="debug && false">
  <mat-form-field>
    <input matInput type="number" class="my-mat-fields" [(ngModel)]="processStatus">
  </mat-form-field>
  <div class="flex-row">
    <button mat-button type="submit" (click)="prevStep()" class="button button-fill color-action button-round w45">
      <span >{{'BUTTONS.PREV' | translate}}</span>
    </button>
    
    <button mat-button type="submit" (click)="nextStep()" class="button button-fill color-action button-round w45">
      <span >{{'BUTTONS.NEXT' | translate}}</span>
    </button>
  </div>
</div>